module.exports = __webpack_public_path__ + "04d607f2eecc33188ce607214ec79e7d.png";